"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("el-button", {
    attrs: {
      mini: "",
      type: "text",
      disabled: _vm.disabled
    },
    on: {
      click: _vm.toggleMask
    }
  }, [_vm._v(" " + _vm._s(_vm.masked ? _vm.maskedValue : _vm.value) + " ")]);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;